import React, { useEffect } from 'react';
import styled from 'styled-components/macro';
import { TABLET_WIDTH } from '../../constants/dims';
import Member from './Member';
import team from './team';
import advisors from './advisors';
import imgBg from '../../assets/img/teamBg.png';

const Container = styled.section`
  width: 100%;
  position: relative;
  color: ${props => props.theme.about.text};
  background-color: ${props => props.theme.about.backgroundColor};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.div`
  width: 100%;
  height: 436px;
  background-color: #0e91a1;
  background-image: url(${imgBg});
  background-repeat: none;
  background-size: cover;
  background-position: center;
  color: white !important;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  position: relative;

  & > h2 {
    text-align: center;
    text-shadow: 0px 0px 10px black;
  }
`;

const Canvas = styled.div`
  max-width: ${TABLET_WIDTH}px;
  padding: 40px 32px;
  box-sizing: border-box;
`;

const Team = styled.div`
  width: 90%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;

const About = () => {
  useEffect(() => {
    document.title = 'Brainquake: Team';
  }, []);

  return (
    <Container>
      <Header>
        <h2>We change the way children experience math</h2>
      </Header>

      <Canvas>
        <h2>Our Team</h2>
        <p>
          BrainQuake’s core team creates some of the most effective and
          innovative math learning products on the planet.
        </p>

        <Team>
          {team.map((d, i) => (
            <Member
              key={i}
              img={d.image}
              name={d.name}
              title={d.title}
              description={d.description}
            />
          ))}
        </Team>

        <h2>Our Advisors</h2>

        <Team>
          {advisors.map((d, i) => (
            <Member
              key={i}
              img={d.image}
              name={d.name}
              title={d.title}
              description={d.description}
            />
          ))}
        </Team>
      </Canvas>
    </Container>
  );
};

export default About;
